import { useSelector } from "react-redux";

import { getActiveTool } from "../state/mainGui";

import DischargeMenu from "./DischargeMenu";
import InfoMenu from "./InfoMenu";
import LayerMenu from "./LayerMenu";
import LeveeEditMenu from "./LeveeEditMenu";
import styles from "./MainScreen.module.css";
import PumpMenu from "./PumpMenu";
import RainMenu from "./RainMenu";
import RasterEditMenu from "./RasterEditMenu";
import WindMenu from "./WindMenu";

const LeftCollapsableSidebar = () => {
  const activeTool = useSelector(getActiveTool);
  const show = activeTool !== null;

  return (
    <div
      className={`
      ${styles.LeftCollapsableSidebar}
      ${styles.CollapsableSidebar}
      ${show ? styles.Visible : undefined}
    `}
    >
      {activeTool === "INFO" ? <InfoMenu /> : null}
      {activeTool === "RAIN" ? <RainMenu /> : null}
      {activeTool === "RASTER_EDIT" ? <RasterEditMenu /> : null}
      {activeTool === "LEVEE_TOOL" ? <LeveeEditMenu /> : null}
      {activeTool === "PUMP" ? <PumpMenu /> : null}
      {activeTool === "DISCHARGE" ? <DischargeMenu /> : null}
      {activeTool === "LAYERS" ? <LayerMenu /> : null}
      {activeTool === "WIND" ? <WindMenu /> : null}
    </div>
  );
};

export default LeftCollapsableSidebar;
